import React from 'react'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from '../HistoryDialog.module.sass'
import NoData from 'components/general/NoData/NoData'

const InjuredStateHistoryRow = (props) => {
	const { data, i18n } = props
	const { injuredState, user, date } = data

	let processInjuredStateColor = ''
	if (injuredState === 'Aceite') {
		processInjuredStateColor = 'accepted'
	} else if (injuredState === 'Recusado') {
		processInjuredStateColor = 'rejected'
	}

	return (
		<HStack className={styles['history-row']}>
			<VStack className={styles['date-column']}>
				<small>
					<strong>{date?.dateTimeFormat || '-'}</strong>
				</small>
				<small>{user || '-'}</small>
			</VStack>
			<HStack className={styles['state-column']} align='center'>
				<div
					className={`${styles['status']} ${
						styles[`--injured-state-${processInjuredStateColor}`]
					}`}
				/>
				<small>{i18n`Injured state changed to ${injuredState}`}</small>
			</HStack>
		</HStack>
	)
}

const InjuredStateHistory = (props) => {
	const { data } = props
	const { processHistory, state } = data

	const { i18n } = useGlobal()

	const modifiedStates = processHistory
		.filter((elem) => elem?.injuredState)
		.reduce((acc, elem) => {
			if (
				!acc.length ||
				elem.injuredState.toLowerCase() !==
					acc[acc.length - 1].injuredState.toLowerCase()
			) {
				acc.push({
					injuredState: elem.injuredState,
					user: elem.modificationUser,
					date: elem.modificationDate,
				})
			}

			return acc
		}, [])

	const isLoading = state === 'loading'

	return !isLoading ? (
		modifiedStates.length ? (
			<VStack className={styles['history-root']}>
				<VStack className={styles['history-container']}>
					{modifiedStates
						.sort((a, b) => b.date?.timestamp - a.date?.timestamp)
						.map((injuredModification, key) => (
							<InjuredStateHistoryRow
								key={key}
								i18n={i18n}
								data={injuredModification}
							/>
						))}
				</VStack>
			</VStack>
		) : (
			<NoData
				applyMaxWidth
				paddings={['normal', 'normal']}
				message={i18n`This process has no extra data to show.`}
			/>
		)
	) : (
		<VStack className={styles['center-content']} justify='space-between'>
			<Icon name='on-going' />
			<small>{i18n`Loading injured state history...`}</small>
		</VStack>
	)
}

export default InjuredStateHistory
